<elder-nav-list class="flex">
  <elder-nav-link
    icon="inventory_2"
    routerLink="app/packages"
    title="packages.title"
    queryParamsHandling="preserve"
  ></elder-nav-link>

  <elder-nav-link
    icon="save_alt"
    routerLink="app/storageGroups"
    title="storageGroups.title"
    queryParamsHandling="preserve"
  ></elder-nav-link>

  <elder-nav-link
    icon="swap_horiz"
    routerLink="app/storage-manager"
    title="storage.management"
    queryParamsHandling="preserve"
  ></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-link
    icon="border_all"
    routerLink="app/storage"
    title="storage.title"
    queryParamsHandling="preserve"
  ></elder-nav-link>

  <mat-divider></mat-divider>

  <elder-nav-link
    icon="settings"
    routerLink="app/settings"
    title="settings.title"
    queryParamsHandling="preserve"
  ></elder-nav-link>
</elder-nav-list>
